import * as React from 'react'

const SvgStarFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.25L7.156 7.013.8 7.93l4.6 4.488-1.088 6.331L10 15.762l5.688 2.988-1.088-6.331 4.6-4.482-6.356-.925L10 1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgStarFilledIcon
